import { EntityRepository, Repository } from "typeorm";
import { TeamCalender } from "../entity/team-calender.entity";
import { TeamCalenderQueryResponse } from "./team-calender.query.response";

@EntityRepository(TeamCalender)
export class TeamCalenderRepository extends Repository<TeamCalender> {

    constructor() {
        super();
    }

    async getShiftGroupRecords(shiftCode: string): Promise<TeamCalenderQueryResponse[]> {
        const query = this.createQueryBuilder('team_calender')
            .select(` shift_code, from_date, to_date, shift `)
            .where(` shift_code = '${shiftCode}'`);
        query.orderBy(` shift_code, from_date`)
        return await query.getRawMany();
    }
}